import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b6df4a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.spinning
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          ((_ctx.allData || []).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_Table, {
                  data: _ctx.pagedData,
                  columns: _ctx.tableColumns,
                  bordered: true,
                  pagination: _ctx.pagination,
                  scroll: { x: '100%' }
                }, null, 8, ["data", "columns", "pagination"])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createVNode(_component_Nodata, { nodatadesc: '暂无财务数据' })
              ]))
        ])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}